import { render, staticRenderFns } from "./PersonSeal.vue?vue&type=template&id=6d8dd961&scoped=true"
import script from "./PersonSeal.vue?vue&type=script&lang=js"
export * from "./PersonSeal.vue?vue&type=script&lang=js"
import style0 from "./PersonSeal.vue?vue&type=style&index=0&id=6d8dd961&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8dd961",
  null
  
)

export default component.exports